import { ButtonBase, Typography, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onClick: () => void;
	label?: string;
	icon?: React.ReactNode;
};

const PageResources = Resources.Dashboard.ShowAllButton;

export const ShowMoreButton: FC<Props> = ({ onClick, label, icon }) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			sx={{
				alignSelf: "flex-start",
				gap: 0.8,
				height: 30,
			}}
		>
			{icon ?? <Plus size={16} color={theme.palette.primary.main} />}
			<Typography variant="body2" color={theme.palette.primary.main}>
				{label ?? t(PageResources.title)}
			</Typography>
		</ButtonBase>
	);
};
